import { Controller, useFormContext } from 'react-hook-form';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@client/new/components/basic';
import { FieldDesc } from './common';

type Side = 'left' | 'right';

export function SelectImageSideInput({
  index,
  defaultSide,
}: {
  index: number;
  defaultSide?: Side;
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={`sections.${index}.swapSides`}
      control={control}
      render={({ field: { value, onChange } }) => (
        <SelectImageSide
          value={value}
          onChange={onChange}
          defaultSide={defaultSide}
        />
      )}
    />
  );
}

function SelectImageSide({
  value,
  onChange,
  defaultSide,
}: {
  value: boolean;
  onChange: (v: boolean) => void;
  defaultSide?: Side;
}) {
  const isRightDefault = defaultSide ? defaultSide === 'right' : true;

  return (
    <div>
      <FieldDesc className="mb-0">Image side: </FieldDesc>
      <RadioGroup
        row
        value={value}
        onChange={(e) => onChange(e.target.value === 'true')}
        defaultValue={false}
        className="mt-0"
      >
        <FormControlLabel
          value={isRightDefault}
          control={<Radio />}
          label="Left"
        />
        <FormControlLabel
          value={!isRightDefault}
          control={<Radio />}
          label="Right"
        />
      </RadioGroup>
    </div>
  );
}
